import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-blue-900 text-white text-center" data-id="element-138">
      <Container className="max-w-3xl" data-id="element-139">
        <ShieldCheck className="w-16 h-16 mx-auto mb-6 text-blue-300" data-id="element-140" />
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-141">
          Sleep Better or Your Money Back—Guaranteed
        </h2>
        <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-142">
          We're so confident SnoreStop™ will change your sleep that we offer a
          60-day, no-questions-asked money-back guarantee. Try it risk-free. If
          you're not sleeping better and your partner isn't happier, we'll
          refund every penny.
        </p>
        <Button onClick={scrollToPricing} variant="secondary" size="lg" className="shadow-xl shadow-blue-950/50" data-id="element-143">
          Try SnoreStop™ Risk-Free
        </Button>
      </Container>
    </section>;
}